import React from "react";
import "../css/DataDisplayOtrasFormas.css";
import { Plus } from "lucide-react";

const UtplIconAnimated = () => {
  // Constante para centralizar los nombres de las clases CSS
  const styles = {
    container: "utpl-icon-animated-wrapper",
    iconBox: "utpl-icon-animated-box",
    mainPlus: "utpl-main-plus-animated",
    sparksWrapper: "utpl-sparks-animated-fly",
    sparkItem: "utpl-spark-animated-item",
    animatedClass: "animate-spark", // Esta es la clase que activa la animación
    textMas: "utpl-animated-text-mas"
  };

  return (
    <div className={styles.container}>
      {/* Bloque Izquierdo: Plus grande + Chispas animadas */}
      <div className={styles.iconBox}>
        {/* Plus principal (Amarillo #febe10) */}
        <Plus className={styles.mainPlus} size={48} strokeWidth={5} />
        
        {/* Contenedor de las Chispas */}
        <div className={styles.sparksWrapper}>
          {/* Chispa 1 (Más grande, Gris medio, con animación) */}
          <Plus 
            className={`${styles.sparkItem} spark-1 ${styles.animatedClass}`} 
            size={16} 
            strokeWidth={3} 
          />
          {/* Chispa 2 (Más pequeña, Gris claro, con animación) */}
          <Plus 
            className={`${styles.sparkItem} spark-2 ${styles.animatedClass}`} 
            size={12} 
            strokeWidth={3} 
          />
        </div>
      </div>

      {/* Bloque Derecho: Texto "más" (Del slogan Decide ser más) */}
      <div className={styles.textMas}>más</div>
    </div>
  );
};


const DataDisplayOtrasFormas = ({ data }) => {
  if (!data || data.length === 0) return null;

  const firstItems = data.slice(0, 5);
  const otherItems = data.slice(5);

  const renderCards = (items) =>
    items.map((item, index) => {
      if (!item) return null;

      return (
        <div className="otras-formas-card" key={index}>
          {item.field_image && (
            <img
              className="otras-formas-icon"
              src={`https://tec.utpl.edu.ec/${item.field_image}`}
              alt={item.field_titulo || "icono"}
            />
          )}

          {item.field_titulo && (
            <h3 className="otras-formas-title">{item.field_titulo}</h3>
          )}

          {item.field_contenido && (
            <div
              className="otras-formas-content"
              dangerouslySetInnerHTML={{
                __html: item.field_contenido,
              }}
            />
          )}

          {item.field_nombre_enlace && (
            <div className="wrapper-otras-formas-link">
              <a
                href={item.field_enlace_contenido}
                target="_blank"
                className="otras-formas-link"
                rel="noopener noreferrer"
              >
                {item.field_nombre_enlace}
              </a>
            </div>
          )}
        </div>
      );
    });

  return (
    <section className="otras-formas-container bluebg padding">
      <div >
        
        {/* HEADER PRINCIPAL */}
        <div className="otras-formas-header">
          <h2>
            Cada estudiante es un mundo y{" "}
            <b>
              en la UTPL tenemos un camino diseñado especialmente para el
              tuyo.
            </b>{" "}
            ¡Hazlo realidad!
          </h2>

          <h2>
            <UtplIconAnimated />
            formas de ingresar <b>a la UTPL</b>
          </h2>
        </div>

        {/* PRIMERAS 4 */}
        <div className="otras-formas-grid">
          {renderCards(firstItems)}
        </div>

        {/* RESTO (solo si hay más) */}
        {otherItems.length > 0 && (
          <>
            <div className="otras-formas-header extra margin">
              <h2>  <UtplIconAnimated /> beneficios</h2>
            </div>

            <div className="otras-formas-grid">
              {renderCards(otherItems)}
            </div>
          </>
        )}

      </div>
    </section>
  );
};

export default DataDisplayOtrasFormas;
